import React from "react"
import DisabledLineItem from "./DisabledLineItem"

class DisabledRoomTypeDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data && this.props.data.name && this.props.data.status == 'enabled') {
      return <div>{this.props.data.name}</div>    
    } else if (this.props.data && this.props.data.name && this.props.data.status == 'disabled') {
      return <DisabledLineItem {...this.props} disabledRoomType={true} /> 
    } else {
      return <div className="none">{I18n.t("none")}</div>
    }
  }
};

export default DisabledRoomTypeDataType